module.exports = __webpack_public_path__ + "static/images/how-it-works-3.81f84e1c064dc3fbb3981d53f35ba35a.png";